import { render, staticRenderFns } from "./SearchWrapper.vue?vue&type=template&id=1bcbb7b4&scoped=true&"
import script from "./SearchWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SearchWrapper.vue?vue&type=style&index=0&id=1bcbb7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbb7b4",
  null
  
)

export default component.exports